<template>
  <div class="banner-container" v-if="showBanners(banners)">
    <b-carousel
        id="carousel-1"
        v-model="slide"
        :interval="interval"
        :controls="countVisibleBanners > 1"
        :indicators="countVisibleBanners > 1"
    >
      <a href="#"  v-for="(banner, i) in banners"
         @click="handleClick(banner.url)"
         :key="i"
         v-if="showBanner(banner)">
        <b-carousel-slide
            :img-src="getBannerImg(banner)"
        ></b-carousel-slide>
      </a>
    </b-carousel>
  </div>
</template>

<script>
  import {mapActions, mapState} from "vuex";
  import Screen from "@/mixins/screen";

  export default {
    name: "Banner",
    mixins: [Screen],
    data() {
      return {
        slide: 0,
        sliding: null,
      }
    },
    mounted() {
      this.fetchBanners();
    },
    methods: {
      ...mapActions([
        'fetchBanners',
        'pushToFirstPage'
      ]),
      showBanners(banners) {
        if (!banners.length) {
          return false;
        }
        return !banners.every((el)=>!this.showBanner(el));
      },
      showBanner(banner) {
        return this.bannerVisibleOnPage(banner) && this.getBannerImg(banner);
      },
      bannerVisibleOnPage(banner) {
        return banner.pages.some((v) => window.location.pathname.endsWith(v+'/') || window.location.pathname.endsWith(v)) //window location exists in pages
          || (banner.pages.includes('MainPage') && window.location.pathname.includes(this.firstPage)) //main page exists in pages
      },
      getBannerImg(banner) {
        if (this.windowWidth < 1024 && banner.pictures.mobile) {
          return  banner.pictures.mobile
        }

        return banner.pictures.desktop;
      },
      handleClick(url) {
        if (url.startsWith('http')) {
          window.open(url, '_blank');
          return;
        }

        if (url) {
          this.$router.push({ name: 'ProfilePage' }); //go to first level of route nesting for proper push to url
          this.$router.push(url);
        }
      },
    },
    computed: {
      ...mapState({
        banners: state => state.banners.banners,
        firstPageJson: state => state.navigation.firstPage,
      }),
      firstPage() {
        if (!this.firstPageJson) {
          return this.firstPageJson;
        }

        return this.$router.resolve(this.firstPageJson).href;
      },
      countVisibleBanners() {
        let count = 0;

        this.banners.forEach((banner) => {
          if (this.showBanner(banner)) {
            count += 1;
          }
        })

        return count;
      },
      interval() {
        return this.countVisibleBanners > 1 ? 4000 : 0;
      }
    },
    watch: {
      '$route.params.pageUuid': {
        handler: function(pageUuid) {
          this.fetchBanners()
        },
        deep: true,
        immediate: true
      }
    }
  }
</script>

<style scoped>
  .banner-container {
    padding: 30px 30px 0;
  }

  @media (max-width: 1024px) {
    .banner-container {
      padding: 20px 20px 0;
    }
  }

  .banner-container >>> .carousel-indicators {
    bottom: -35px !important;
  }

  .banner-container >>> .carousel-indicators .active {
    background-color: var(--accent-color);
  }

  .banner-container >>> .carousel-indicators li {
    background-color: lightgrey;
  }
</style>
